import { render, staticRenderFns } from "./SubmissionDetails.vue?vue&type=template&id=6efe0f78&scoped=true"
import script from "./SubmissionDetails.vue?vue&type=script&lang=js"
export * from "./SubmissionDetails.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetails.vue?vue&type=style&index=0&id=6efe0f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe0f78",
  null
  
)

export default component.exports